/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue';

const nl2br = function nl2br(str, isXhtml) {
  const breakTag = (isXhtml || typeof isXhtml === 'undefined') ? '<br />' : '<br>';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, `$1${breakTag}$2`);
};

Vue.filter('nl2br', value => nl2br(value));

export default nl2br;

